import cx from 'classnames';
import cn from './ToolbarSpacer.css.json';
import './ToolbarSpacer.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolbarSpacer = props => {
  return /*#__PURE__*/_jsx("div", {
    "data-testid": props.testId,
    className: cx(cn.toolbarSpacer, props.className),
    style: props.style
  });
};
//# sourceMappingURL=ToolbarSpacer.js.map